import { Head, Link } from "@inertiajs/react"
import { ArrowLeft } from "lucide-react"
import { AdminShell } from "@/components/AdminShell"
import { PageHeader } from "@/components/PageHeader"
import { AccessGroupForm } from "@/components/admin/AccessGroupForm"
import { FlashNotice } from "@/components/admin/FlashNotice"
import type { AccessApp, AccessGroupRow, LevelOption } from "@/types/access"

const DESCRIPTION = "Create an access group: a name, and a level on every app for the people in it."

export default function AdminAccessGroupsNew({
  group,
  apps,
  levels,
}: {
  group: AccessGroupRow
  apps: AccessApp[]
  levels: LevelOption[]
}) {
  return (
    <>
      <Head title="New group">
        <meta name="description" content={DESCRIPTION} />
        <meta property="og:title" content="New group" />
        <meta property="og:description" content={DESCRIPTION} />
      </Head>
      <AdminShell>
        <Link
          href="/admin/access_groups"
          className="mb-4 inline-flex items-center gap-1.5 text-sm no-underline"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to groups
        </Link>

        <PageHeader
          title="New group"
          description="Every app starts at No Access, so creating a group never gives anybody more than you choose. You add people once it is saved."
        />

        <div className="mt-6">
          <FlashNotice />
        </div>

        <AccessGroupForm group={group} apps={apps} levels={levels} submitLabel="Create group" />
      </AdminShell>
    </>
  )
}
